<template>
  <div
    v-if="value"
    :class="[ value ? 'fadeIn' : 'fadeOut' ]"
    class="animated menu-item-details"
    @click.self="close"
  >
    <div class="bg-white w-modal-lg overflow-hidden">
      <header
        :class="entree?.banner ? 'pb-2 sm:px-0' : 'px-8 py-2 sm:px-4'"
        class="block rounded-t w-full text-primary-500"
      >
        <section class="flex-grow flex-shrink-0">
          <div :class="entree.banner ? 'absolute right-2 top-2' : 'flex justify-end'">
            <w-button
              :class="[
                entree.banner ?
                  'bg-white hover:bg-white px-2 py-1 rounded-full sm:py-1' :
                  'left-4 mb-2',
              ]"
              class="relative sm:left-0"
              variant="icon"
              @click="close"
            >
              <i class="text-xs icon-cross" />
            </w-button>
          </div>
          <div v-if="entree.banner" class="h-[300px] max-h-[300px] sm:h-auto sm:max-h-max mb-2">
            <img
              :alt="`Banner - ${entree.name}`"
              :src="entree.banner"
              class="h-[300px] max-h-[300px] sm:h-auto sm:max-h-max w-full"
            />
          </div>
          <h1
            :class="{ 'px-8 sm:px-4': entree.banner }"
            :title="entree.name"
            class="line-clamp-2 sm:text-xl text-2xl text-black"
          >
            {{ entree.name }}
          </h1>
        </section>
      </header>
      <div class="max-h-screen-1/2 min-h-[24px] overflow-y-auto scrolling-touch">
        <div
          v-if="entree.storeNote"
          class="max-h-modal-content min-h-modal-content overflow-y-auto px-8 sm:px-4 sm:min-h-0"
        >
          <p :title="entree.storeNote" class="text-gray-500">
            {{ entree.storeNote }}
          </p>
          <div v-if="showDivider" class="bg-light-gray-500 h-[1px] mt-2 w-full" />
        </div>
        <menu-item-options
          v-if="hasOptions"
          :entree="entree"
          :entree-identifier="entreeIdentifier"
          :options="entree.options"
          @is-options-valid="onOptionsValidation"
        />
      </div>
      <footer class="bg-light-yellow pb-4 pt-2 px-8 rounded-b sm:px-4">
        <section class="flex flex-col">
          <w-input
            v-if="enableOrderNote"
            :disabled="isScheduled"
            :max="40"
            show-count
            placeholder="若有特殊需求，請備註在此。"
            v-model="note"
          />
          <div class="flex justify-between sm:flex-col">
            <div>
              <div class="flex sm:justify-between sm:mb-2 sm:w-full">
                <w-button
                  :disabled="isScheduled || count <= minCount"
                  class="menu-item-details__footer--button"
                  variant="avatar"
                  @click="countMinus"
                >
                  <i class="icon-minus" />
                </w-button>
                <t-input
                  v-model.number="count"
                  :class="{
                    'border-red-500': (remaining < 0),
                    'focus:border-red-500': (remaining < 0),
                  }"
                  :disabled="!available"
                  :readonly="isScheduled"
                  :maxlength="countInputMaxLength"
                  :max="maxCount"
                  :min="minCount"
                  class="
                    mx-4
                    px-0
                    py-0
                    text-center
                    text-3xl
                    w-14
                    disabled:rounded-sm
                    disabled:border"
                  type="number"
                  variant="clear"
                  @keypress.native="filterOnlyNumberAndLengthSmallerThanMaxLength"
                />
                <w-button
                  :disabled="isScheduled || !available || count >= maxCount"
                  class="menu-item-details__footer--button"
                  variant="avatar"
                  @click="countPlus"
                >
                  <i class="icon-add" />
                </w-button>
              </div>
              <template v-if="hasLimit">
                <div
                  v-if="remaining < 0"
                  class="text-xs text-red-500 mt-1 text-center sm:mb-2"
                >
                  剩餘可訂購數： {{ available }}
                </div>
                <div
                  v-else-if="available"
                  class="text-xs text-gray-500 mt-1 text-center sm:mb-2"
                >
                  可訂購數： {{ available }}
                </div>
              </template>
            </div>
            <template v-if="!isScheduled">
              <w-button v-if="!available" disabled class="py-3 sm:w-full w-70">
                <span>訂購已達上限</span>
              </w-button>
              <w-button v-else-if="remaining < 0" disabled class="py-3 sm:w-full w-70">
                <span>請修改訂購數量</span>
              </w-button>
              <w-button
                v-else
                :disabled="disableAdd"
                class="py-3 sm:w-full w-70"
                @click="addToCart"
              >
                <span class="mr-2">
                  加入購物車
                </span>
                <span>
                  {{ total | commaFormat | priceFormat }}
                </span>
              </w-button>
            </template>
            <span v-else class="py-3 sm:w-full text-xl text-center text-primary-500 w-70">
              即將在 {{ expectedStartPeriod.start_date }} {{ expectedStartPeriod.start_time }} 開放訂購
            </span>
          </div>
        </section>
      </footer>
      <clear-cart-dialog
        v-if="showClearDialog"
        v-bind="clearCartData"
        v-model="showClearDialog"
        @close="showClearDialog = false"
        @close-details="close"
      />
    </div>
  </div>
</template>

<script>
import MenuItemDetails from './MenuItemDetails';

export default MenuItemDetails;
</script>

<style lang="scss" scoped>
@import 'MenuItemDetails';
</style>
